import { HttpErrorResponse } from "@angular/common/http";

export const handleError = (err: HttpErrorResponse): any => {
  let {
    fields,
    message = "Erro ao realizar requisição. Tente novamente!",
    code = "",
  } = err?.error?.error || err?.error;

  if (!fields) {
    fields = err.error.errors;
  }

  return { fields, message, code };
};
